<template>
  <div>
    <v-alert v-if="msg" :type="msgType">{{ msg }}</v-alert>
    <ListPage ref="appTable" :endpoint="apiCall" :headers="headers" title="Customers" :showActionsColumn="true"
      :showAddButton="isAllowed('createCustomer')" :showEditButton="isAllowed('editCustomer')"
      :showDeleteButton="isAllowed('deleteCustomer')" :showViewButton="isAllowed('viewCustomer')" :showExportButton="isAllowed('deleteCustomer')" 
      @add="navigateTo('/app/customers/0')" @edit="navigateTo(`/app/customers/${$event._id}`)"
      @delete="deleteCustomer($event._id)" @view="navigateTo(`/app/customers/view/${$event._id}`)">
      <template v-slot:extended-action-buttons>
        <import-file-button importData='customers' class="ml-2"></import-file-button>
      </template>
      <!-- Mobile View -->
      <template v-slot:item="{ item }" v-if="isMobile">
        <customer-card :id="item._id" :name="`${item.firstName} ${item.lastName}`" :mobileNo="item.mobileNo"
          :email="item.email" :icons="icons" @delete="deleteCustomer($event)"></customer-card>
        <v-divider></v-divider>
      </template>
    </ListPage>
    <alert-message v-if="msg" :error="msg"></alert-message>
  </div>
</template>

<script>
import ActionButton from '@/components/ActionButton';
import appConstants from '@/utils/appConstants';
import CustomerCard from '@/components/UserResponsiveCard';
import ListPage from '@/components/common/ListPage.vue';
import ImportFileButton from '../../../components/ImportFileButton.vue';

export default {
  components: {
    ActionButton,
    CustomerCard,
    ListPage,
    ImportFileButton
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'First Name', value: 'firstName', exportable:true },
        { text: 'Middle Name', value: 'middleName', exportable:true },
        { text: 'Last Name', value: 'lastName', exportable:true },
        { text: 'Mobile No', value: 'mobileNo', exportable:true },
        { text: 'E-Mail', value: 'email', exportable:true },
        { text: 'Actions', value: 'action', align: 'right', exportable:false },
      ],
      items: [],
      icons: [
        { name: 'mdi-pencil', path: '/app/customers/', permission: 'editCustomer' },
        { name: 'mdi-delete', permission: 'deleteCustomer' },
      ],
      loading: false,
      apiCall: `${appConstants.CUSTOMERS_API}?userType=CUSTOMER`,
    };
  },
  methods: {
    async deleteCustomer(id) {
      try {
        await this.deleteItem(
          'Are you sure you want to delete this Customer?',
          `${appConstants.CUSTOMERS_API}/${id}`
        );
        this.items.splice(this.items.findIndex((rec) => rec._id === id), 1);
        this.$refs.appTable.loadData()
      } catch (error) {
        this.handleError(error);
        this.msg = error.response.data;
      }
    },
    removeItem(id) {
      this.deleteCustomer(id);
    },
    navigateTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
